import { SxProps } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Dayjs } from 'dayjs';
import { ReactNode } from 'react';
import zeplinColor from 'theme/Color';

const CustomDatePicker = ({
  value,
  setValue,
  label,
  required = false,
  size = 'medium',
  sx,
}: {
  value: Dayjs | null;
  label?: string | ReactNode;
  size?: 'small' | 'medium';
  setValue: React.Dispatch<React.SetStateAction<Dayjs | null>>;
  required?: boolean;
  sx?: SxProps;
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label ? label : 'Due date'}
        sx={{ ...sx, width: '100%', '& .MuiFormLabel-asterisk': { color: zeplinColor.Error } }}
        slotProps={{
          textField: {
            required: required ? true : false,
            size: size ? size : 'medium',
          },
        }}
        value={value || null}
        onChange={(newValue) => setValue(newValue)}
        slots={{
          openPickerIcon: () => (
            <img src={'/assets/calendar.svg'} width={19} height={19} alt='calendar icon' />
          ),
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
